



















































































import { MapType, MapOptions, Expression, MapOps, Exprs } from 'expangine-runtime';
import { SimpleFieldSettings, friendlyList } from '../../../common';
import { TypeUpdateEvent } from '../TypeVisuals';
import { MapSubs } from './MapTypes';
import TypeEditorBase from '../TypeEditorBase';


export default TypeEditorBase<MapType, any, MapSubs>().extend({
  name: 'MapEditor',
  computed: {
    requiredKey() {
      return this.requiredType && this.requiredType instanceof MapType
        ? this.requiredType.options.key
        : null;
    },
    requiredValue() {
      return this.requiredType && this.requiredType instanceof MapType
        ? this.requiredType.options.value
        : null;
    },
  },
  methods: {
    onChangeKey(event: TypeUpdateEvent) {
      this.type.options.key = event.type;
      this.$set(this.settings.sub, 'key', event.settings);

      const transform = event.transform
        ? this.type.getValueChangeExpression(event.transform, MapType.STEP_KEY, MapType.STEP_KEY)
        : undefined;

      this.change({ transform });
    },
    onChangeValue(event: TypeUpdateEvent) {
      this.type.options.value = event.type;
      this.$set(this.settings.sub, 'value', event.settings);

      const transform = event.transform
        ? this.type.getValueChangeExpression(event.transform, MapType.STEP_VALUE, MapType.STEP_VALUE)
        : undefined;

      this.change({ transform });
    },
  },
});
